var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#1D7A70","fillRule":"nonzero"},[React.createElement("path",{"d":"M24 .5C11.021.5.5 11.021.5 24S11.021 47.5 24 47.5 47.5 36.979 47.5 24 36.979.5 24 .5zm0 3c11.322 0 20.5 9.178 20.5 20.5S35.322 44.5 24 44.5 3.5 35.322 3.5 24 12.678 3.5 24 3.5z","key":0}),React.createElement("path",{"d":"M19.025 33.545a1.24 1.24 0 0 1-.183-.147l-7.311-7.087a1.175 1.175 0 0 1-.003-1.699 1.269 1.269 0 0 1 1.753.002l6.54 6.339 14.898-14.44a1.264 1.264 0 0 1 1.75.002c.482.467.484 1.228.001 1.696L20.71 33.486a1.265 1.265 0 0 1-1.685.059z","key":1})]));
}

CheckInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
